export default {
  API_URL: 'https://kanadeviainova-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://kanadeviainovasandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
